// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"d3805339a2dc9c061f5c","453":"baff912bd3d87b489a83"}[chunkId] + ".js";
};